export default __webpack_public_path__ + "static/media/radio_animation.78430076.gif";